import React from 'react';

function ComplianceScore({ result, isProcessing, mode }) {
  if (isProcessing) {
    return (
      <div className="compliance-score card">
        <h3 className="card-title">Compliance Score</h3>
        <div className="score-placeholder">
          <div className="shimmer-circle"></div>
        </div>
      </div>
    );
  }

  if (!result) return null;

  const score = result.complianceScore;
  const summary = result.summary || {};

  let scoreClass = 'score-good';
  let scoreLabel = 'Compliant';
  if (score < 50) {
    scoreClass = 'score-critical';
    scoreLabel = 'Critical';
  } else if (score < 80) {
    scoreClass = 'score-warning';
    scoreLabel = 'Needs Attention';
  }

  // SVG circle math
  const radius = 60;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference - (score / 100) * circumference;

  return (
    <div className="compliance-score card">
      <h3 className="card-title">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="currentColor">
          <path d="M9 1L2 4v5c0 4.25 2.99 8.23 7 9 4.01-.77 7-4.75 7-9V4L9 1zm-1 12.5L5 10.5l1.41-1.41L8 10.67l3.59-3.59L13 8.5l-5 5z"/>
        </svg>
        Compliance Score
      </h3>

      <div className="score-ring-container">
        <svg className="score-ring" width="150" height="150" viewBox="0 0 150 150">
          <circle cx="75" cy="75" r={radius} fill="none" stroke="#1e2540" strokeWidth="10"/>
          <circle
            cx="75" cy="75" r={radius}
            fill="none"
            className={`score-ring-progress ${scoreClass}`}
            strokeWidth="10"
            strokeLinecap="round"
            strokeDasharray={circumference}
            strokeDashoffset={strokeDashoffset}
            transform="rotate(-90 75 75)"
          />
          <text x="75" y="70" textAnchor="middle" className="score-value">{score}%</text>
          <text x="75" y="90" textAnchor="middle" className="score-label">{scoreLabel}</text>
        </svg>
      </div>

      <div className="summary-stats">
        <div className="stat-item">
          <span className="stat-value">{summary.totalPersons || 0}</span>
          <span className="stat-label">
            {mode === 'public-sector' ? 'Workers' : 'Personnel'}
          </span>
        </div>
        <div className="stat-item stat-good">
          <span className="stat-value">{summary.helmetsDetected || 0}</span>
          <span className="stat-label">Helmets</span>
        </div>
        <div className="stat-item stat-good">
          <span className="stat-value">{summary.vestsDetected || 0}</span>
          <span className="stat-label">Vests</span>
        </div>
        <div className="stat-item stat-bad">
          <span className="stat-value">{summary.violations || 0}</span>
          <span className="stat-label">Violations</span>
        </div>
      </div>

      {result.inspectionId && (
        <a
          href={`http://localhost:5002/api/inspect/${result.inspectionId}/export`}
          target="_blank"
          rel="noopener noreferrer"
          className="export-btn"
        >
          <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
            <path d="M8 1a.5.5 0 01.5.5v8.793l2.146-2.147a.5.5 0 01.708.708l-3 3a.5.5 0 01-.708 0l-3-3a.5.5 0 11.708-.708L7.5 10.293V1.5A.5.5 0 018 1zM2 13.5a.5.5 0 01.5-.5h11a.5.5 0 010 1h-11a.5.5 0 01-.5-.5z"/>
          </svg>
          Export Report (JSON)
        </a>
      )}
    </div>
  );
}

export default ComplianceScore;
